import request from '@/utils/request'

export function getProductTypeList() {
    return request({
        url: '/website/pc/product/type/list',
        method: 'get'
    })
}

export function getProductCount(typePath) {
    return request({
        url: '/website/pc/product/count/' + typePath,
        method: 'get'
    })
}

export function getProductList(typeId, pageNum, pageSize) {
    return request({
        url: '/website/pc/product/list/' + typeId + '?pageNum=' + pageNum + '&pageSize=' + pageSize,
        method: 'get'
    })
}

export function getProductById(id) {
    return request({
        url: '/website/pc/product/' + id,
        method: 'get'
    })
}